<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        h3.title Autotanques
          | &nbsp
          a.button.is-primary.is-rounded.is-medium(@click="newAutotanque")
            i.fas.fa-plus
        .columns(v-show="!verFormNuevoPG")
          .column.is-4
            .field
              label.label Autotanque
              TypeaheadPG(:options="autotanques" :optionSelect="itemDataAuto" v-model="itemSelAuto")
          .column.is-8(v-show="verFormPg")
            .columns
              .column.is-6
                .field
                  label.label Capacidad (Litros)
                  .control
                    input.input.is-primary(
                      type='text', 
                      v-model="itemSelAuto.capacidad",
                      :disabled="isformPgDisabled"
                    )
              .column.is-6
                .field
                  label.label Placa
                  .control
                    input.input.is-primary(
                      type='text', 
                      v-model="itemSelAuto.placa",
                      :disabled="isformPgDisabled"
                    )
            .columns
              .column.is-12
                .field
                  label.label Transportista
                  TypeaheadPorteador(:options="porteadores" :optionSelect="itemDataPort" v-model="itemSelPort" :isDisabled="isformPgDisabled")
            .columns
              .column.is-8
                .field
                  label.label Comercializadora
                    .control.has-icons-left
                      .select.is-primary.is-rounded
                        select(v-model="itemSelAuto.comercializadora" :disabled="isformPgDisabled")
                          option(value="" checked) Seleccione una Comercializadora
                          option(v-for="comer in comercializadoras" :key="comer.id" :value="comer.nombre") {{ comer.nombre }}
                      .icon.is-small.is-left
                        i.fas.fa-tag
              .column.is-4
                .field
                  label.label Grupo
                    .control.has-icons-left
                      .select.is-primary.is-rounded
                        select(v-model="itemSelAuto.grupo" :disabled="isformPgDisabled")
                          option(value="" checked) Seleccione el Grupo
                          option(v-for="gr in grupos" :key="gr.id" :value="gr.id") {{ gr.nombre }}
                      .icon.is-small.is-left
                        i.fas.fa-tag
            .columns
              .column.is-6
                .field
                  label.label ID CRE
                  .control
                    input.input.is-primary(
                      type='text', 
                      v-model="itemSelAuto.idCRE",
                      :disabled="isformPgDisabled"
                    )
            .columns
              .column.is-6
                button.button.is-warning(@click="editPg" v-show="isformPgEditing")
                  | Editar
                | &nbsp
                button.button.is-info(@click="updatePg" v-show="isformPgUpdating")
                  | Actualizar
                | &nbsp
                button.button.is-default(@click="cancelUpdPg" v-show="isformPgUpdating")
                  | Cancelar
                | &nbsp
                button.button.is-dark(@click="closeFormPg" v-show="isformPgEditing")
                  | Cerrar
                | &nbsp
        .columns
          NewAutotanque(v-show="verFormNuevoPG" @closeForm="checkFormNew")
        .columns.column-blanco
</template>

<script>
  import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
  import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
  import TypeaheadPG from '@/components/sca_Componentes/acceso/shared/TypeaheadPG.vue'
  import NewAutotanque from '@/components/sca_Componentes/acceso/NewAutotanque.vue'
  import TypeaheadPorteador from '@/components/sca_Componentes/acceso/shared/TypeaheadPorteador.vue'
  import Loader from '@/components/shared/Loader.vue'

  export default {
    name: 'Autotanques',
    components: { NavBarAccesos, Loader, TypeaheadPG, NewAutotanque, TypeaheadPorteador },
    data() {
      return {
        isLoading: true,
        autotanques: [],
        itemDataAuto: {},
        itemSelAuto: {},
        porteadores: [],
        itemDataPort: {},
        itemSelPort: {},
        isformPgDisabled: true,
        isformPgEditing: false,
        isformPgUpdating: false,
        verFormPg: false,
        verFormNuevoPG: false,
        grupos: [
          { id:"NIETO", nombre:"Nieto" },
          { id:"MABARAK", nombre:"Mabarak" },
          { id:"URIBE", nombre:"Uribe" },
          { id:"METROPOLITANO", nombre:"Metropolitano" },
          { id:"FLENSA", nombre:"Flensa" },
          { id:"TOMZA", nombre:"Tomza" }
        ],
        comercializadoras: [
          { id: 1, nombre: 'PROPANGOL'},
          { id: 2, nombre: 'MOVENERGY'}
        ],
      }
    },
    watch: {
      itemSelAuto () {
        console.log(this.itemSelAuto)
        this.isformPgEditing = true
        this.verFormPg = true
        this.itemDataPort = this.porteadores.find( p => p.nombre === this.itemSelAuto.porteador )
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerAutos()
      },
      obtenerAutos() {
        this.isLoading = true
        autotanquesServicesIRGE.searchPG_All()
          .then(res => {
            console.log(res)
            this.autotanques = res
            this.obtenerPorteadores()
            setTimeout(() => {
              this.isLoading = false
            }, 250)
          })
          .catch( e => {
            console.log(e)
            this.isLoading = false
          })
      },
      obtenerPorteadores () {
        console.log('Obtener Porteadores')
        autotanquesServicesIRGE.getPorteadores()
          .then(resPort => {
            console.log(resPort)
            this.porteadores = resPort
          })
      },
      editPg () {
        this.isformPgDisabled = false
        this.isformPgEditing = false
        this.isformPgUpdating = true
      },
      updatePg () {
        this.isLoading = true
        this.isformPgDisabled = true
        this.isformPgEditing = true
        this.isformPgUpdating = false

        autotanquesServicesIRGE.actualizarTanque (this.itemSelAuto.SbiID, this.itemSelAuto.comercializadora, this.itemSelPort.nombre, this.itemSelAuto.grupo, this.itemSelAuto.capacidad, this.itemSelAuto.placa, this.itemSelAuto.idCRE)
          .then( resp => {
            if (resp.success) {
              let toast = this.$toasted.show(`El autotanque ha sido Actualizado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'check',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              this.isLoading = false
              this.cancelUpdPg()
              
            } else {
              let toast = this.$toasted.show(`Error: El autotanque No se ha sido actualizar.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'exclamation-triangle',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch( e => console.log(e))
      },
      cancelUpdPg () {
        this.isformPgDisabled = true
        this.isformPgEditing = true
        this.isformPgUpdating = false
      },
      closeFormPg () {
        this.verFormPg = false
      },
      newAutotanque () {
        this.verFormNuevoPG = true
      },
      checkFormNew (val) {
        console.log(val)
        this.verFormNuevoPG = false
        if ( val === 'save') {
          this.obtenerAutos()
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/Autotanques.vue